// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tone sets --csc-tone (icon colour + tint); everything else is shared.
   Prefixed "csc-tone-" so a tone name can never clash with an element
   class (e.g. tone "info" vs the "?" icon's .csc-info). */
.csc-tone-primary { --csc-tone: var(--cui-primary); }
.csc-tone-success { --csc-tone: var(--cui-success); }
.csc-tone-danger  { --csc-tone: var(--cui-danger); }
.csc-tone-warning { --csc-tone: var(--cui-warning); }
.csc-tone-info    { --csc-tone: var(--cui-info); }
.csc-tone-neutral { --csc-tone: var(--cui-text-muted); }

.csc-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 0;
  margin: 0;
  padding: 16px 18px;
  border: 1px solid var(--cui-border-soft);
  border-radius: var(--cui-radius-lg);
  background: var(--cui-bg);
  box-shadow: var(--cui-shadow-sm);
  font: inherit;
  text-align: left;
  color: inherit;
  transition: transform var(--cui-transition), box-shadow var(--cui-transition),
    border-color var(--cui-transition);
}

.csc-clickable {
  cursor: pointer;
}

.csc-clickable:hover {
  transform: translateY(-2px);
  border-color: var(--cui-border-hover);
  box-shadow: var(--cui-shadow-md);
}

.csc-clickable:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

/* Selected card: border + soft tint in the tone colour */
.csc-active,
.csc-active.csc-clickable:hover {
  border-color: var(--csc-tone);
  box-shadow: 0 0 0 1px var(--csc-tone), var(--cui-shadow-sm);
}

.csc-active .csc-value {
  color: var(--csc-tone);
}

.csc-action {
  display: flex;
  flex-shrink: 0;
  margin-left: auto;
}

.csc-head {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.csc-icon {
  position: relative;
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 9px;
  color: var(--csc-tone);
}

/* Tinted square in the tone colour */
.csc-icon::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: var(--csc-tone);
  opacity: 0.12;
}

.csc-icon svg {
  position: relative;
}

.csc-title {
  min-width: 0;
  overflow: hidden;
  color: var(--cui-text-label);
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.csc-info {
  display: grid;
  place-items: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--cui-border-soft);
  color: var(--cui-text-muted);
  font-size: 9.5px;
  font-weight: 700;
  cursor: help;
}

.csc-value {
  display: block;
  margin-top: 14px;
  color: var(--cui-text);
  font-size: clamp(18px, 1.6vw, 22px);
  font-weight: 700;
  line-height: 1.2;
  overflow-wrap: anywhere;
  font-variant-numeric: tabular-nums;
}

.csc-skeleton {
  display: block;
  width: 60%;
  height: 24px;
  margin-top: 14px;
  border-radius: 6px;
  background: linear-gradient(90deg, var(--cui-bg-hover) 25%, var(--cui-border-soft) 37%, var(--cui-bg-hover) 63%);
  background-size: 400% 100%;
  animation: csc-shimmer 1.3s ease infinite;
}

.csc-foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}

.csc-sub {
  color: var(--cui-text-muted);
  font-size: 11.5px;
  line-height: 1.4;
}

.csc-subtitle {
  display: block;
  margin-top: 6px;
}

.csc-trend {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 700;
}

.csc-trend-good {
  background: var(--cui-success-soft);
  color: var(--cui-success);
}

.csc-trend-bad {
  background: var(--cui-danger-soft);
  color: var(--cui-danger);
}

.csc-trend-flat {
  background: var(--cui-bg-hover);
  color: var(--cui-text-muted);
}

@keyframes csc-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: 0 0; }
}

@media (max-width: 576px) {
  .csc-card {
    padding: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomStatCard/CustomStatCard.css"],"names":[],"mappings":"AAAA;;0DAE0D;AAC1D,oBAAoB,8BAA8B,EAAE;AACpD,oBAAoB,8BAA8B,EAAE;AACpD,oBAAoB,6BAA6B,EAAE;AACnD,oBAAoB,8BAA8B,EAAE;AACpD,oBAAoB,2BAA2B,EAAE;AACjD,oBAAoB,iCAAiC,EAAE;;AAEvD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd;sCACoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA,yDAAyD;AACzD;;EAEE,6BAA6B;EAC7B,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gHAAgH;EAChH,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,wBAAwB,EAAE;AACnC;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Tone sets --csc-tone (icon colour + tint); everything else is shared.\n   Prefixed \"csc-tone-\" so a tone name can never clash with an element\n   class (e.g. tone \"info\" vs the \"?\" icon's .csc-info). */\n.csc-tone-primary { --csc-tone: var(--cui-primary); }\n.csc-tone-success { --csc-tone: var(--cui-success); }\n.csc-tone-danger  { --csc-tone: var(--cui-danger); }\n.csc-tone-warning { --csc-tone: var(--cui-warning); }\n.csc-tone-info    { --csc-tone: var(--cui-info); }\n.csc-tone-neutral { --csc-tone: var(--cui-text-muted); }\n\n.csc-card {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 16px 18px;\n  border: 1px solid var(--cui-border-soft);\n  border-radius: var(--cui-radius-lg);\n  background: var(--cui-bg);\n  box-shadow: var(--cui-shadow-sm);\n  font: inherit;\n  text-align: left;\n  color: inherit;\n  transition: transform var(--cui-transition), box-shadow var(--cui-transition),\n    border-color var(--cui-transition);\n}\n\n.csc-clickable {\n  cursor: pointer;\n}\n\n.csc-clickable:hover {\n  transform: translateY(-2px);\n  border-color: var(--cui-border-hover);\n  box-shadow: var(--cui-shadow-md);\n}\n\n.csc-clickable:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n/* Selected card: border + soft tint in the tone colour */\n.csc-active,\n.csc-active.csc-clickable:hover {\n  border-color: var(--csc-tone);\n  box-shadow: 0 0 0 1px var(--csc-tone), var(--cui-shadow-sm);\n}\n\n.csc-active .csc-value {\n  color: var(--csc-tone);\n}\n\n.csc-action {\n  display: flex;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.csc-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.csc-icon {\n  position: relative;\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border-radius: 9px;\n  color: var(--csc-tone);\n}\n\n/* Tinted square in the tone colour */\n.csc-icon::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  background: var(--csc-tone);\n  opacity: 0.12;\n}\n\n.csc-icon svg {\n  position: relative;\n}\n\n.csc-title {\n  min-width: 0;\n  overflow: hidden;\n  color: var(--cui-text-label);\n  font-size: 13px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.csc-info {\n  display: grid;\n  place-items: center;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: var(--cui-border-soft);\n  color: var(--cui-text-muted);\n  font-size: 9.5px;\n  font-weight: 700;\n  cursor: help;\n}\n\n.csc-value {\n  display: block;\n  margin-top: 14px;\n  color: var(--cui-text);\n  font-size: clamp(18px, 1.6vw, 22px);\n  font-weight: 700;\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n  font-variant-numeric: tabular-nums;\n}\n\n.csc-skeleton {\n  display: block;\n  width: 60%;\n  height: 24px;\n  margin-top: 14px;\n  border-radius: 6px;\n  background: linear-gradient(90deg, var(--cui-bg-hover) 25%, var(--cui-border-soft) 37%, var(--cui-bg-hover) 63%);\n  background-size: 400% 100%;\n  animation: csc-shimmer 1.3s ease infinite;\n}\n\n.csc-foot {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.csc-sub {\n  color: var(--cui-text-muted);\n  font-size: 11.5px;\n  line-height: 1.4;\n}\n\n.csc-subtitle {\n  display: block;\n  margin-top: 6px;\n}\n\n.csc-trend {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 7px;\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 700;\n}\n\n.csc-trend-good {\n  background: var(--cui-success-soft);\n  color: var(--cui-success);\n}\n\n.csc-trend-bad {\n  background: var(--cui-danger-soft);\n  color: var(--cui-danger);\n}\n\n.csc-trend-flat {\n  background: var(--cui-bg-hover);\n  color: var(--cui-text-muted);\n}\n\n@keyframes csc-shimmer {\n  0% { background-position: 100% 0; }\n  100% { background-position: 0 0; }\n}\n\n@media (max-width: 576px) {\n  .csc-card {\n    padding: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
